export type ConfigBuilder<TConfig extends object> = (_origin: TConfig) => TConfig;

export function getMergedConfig<TConfig extends object>(
  config?: Partial<TConfig> | ConfigBuilder<TConfig>,
  origin?: TConfig,
): TConfig {
  const newInstance = { ...origin } as TConfig;
  if (!config) {
    return newInstance;
  }
  if (typeof config === 'function') {
    return config(newInstance);
  }
  return { ...origin, ...config } as TConfig;
}
